import React, { FC } from 'react'

import { Txt } from 'src/components/atoms'

type Props = {}

export const ProjectEmailDisplayNameTooltipContent: FC<Props> = () => {
  return (
    <Txt sizeType="s">
      お客様にメールが送信される際に表示される差出人名です。
      <br />
      送信元名を設定するには、<b>送信元メールアドレスの指定が必須</b>です。
    </Txt>
  )
}
